import axios from 'axios';

import { alexaEvents } from '../config';

class AlexaEventsService {
  static all() {
    return axios
      .get(`${alexaEvents.url}/events`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'X-Api-Key': alexaEvents.apiKey,
        },
      })
      .then(response => response.data);
  }
}

export default AlexaEventsService;